import './opentelemetry-bootstrap'; // ✅ Load OpenTelemetry before anything else
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { enableProdMode } from '@angular/core';
import { AppConfigService } from './app/services/app-config.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideHttpClient, withFetch } from '@angular/common/http';

fetch('/config/config.json')
  .then(response => response.json())
  .then(config => {
    const configService = new AppConfigService();
    configService.load(config);

    if (config.stage !== 'local') {
      enableProdMode();
    }

    // Add configService to the appConfig's providers dynamically
    appConfig.providers?.unshift({
      provide: AppConfigService,
      useValue: configService,
    });
    appConfig.providers.push(provideCharts(withDefaultRegisterables()));
    appConfig.providers.push(provideHttpClient(withFetch()));

    bootstrapApplication(AppComponent, appConfig).catch(err =>
      console.error(err)
    );
  });
